"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageService = void 0;
// this only validates the format of message
const isValidMessage = (message) => {
    const data = message.data;
    if (typeof data !== "object")
        return false;
    const { id, type, res } = data;
    return id !== undefined && type !== undefined && res !== undefined;
};
function makeRandomString(length = 16) {
    let result = "";
    while (result.length < length) {
        // convert to hex character
        result += Math.floor(Math.random() * 16).toString(16);
    }
    return result;
}
class MessageService {
    constructor(defaultWindow, options = {}) {
        this.defaultWindow = defaultWindow;
        this.options = options;
        this.callbacks = new Map();
        this.onMessage = (message) => {
            if (!isValidMessage(message))
                return;
            this.handleIncomingMessage(message.data);
        };
        this.handleIncomingMessage = (data) => {
            const { id } = data;
            if (this.options.debug)
                console.log("MessageService received message", data);
            const cb = this.callbacks.get(id);
            if (cb) {
                cb(data.res);
                this.callbacks.delete(id);
            }
        };
        window.addEventListener("message", this.onMessage);
    }
    send(type, payload, timeout = 1500, target = "*", overrideWindow) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = makeRandomString(16);
            const targetWindow = overrideWindow || this.defaultWindow;
            if (this.options.debug)
                console.log(`MessageService posted ${type} message`, payload);
            targetWindow.postMessage({ id, type, payload }, target);
            return new Promise((resolve, reject) => {
                let timeoutId;
                if (timeout > 0) {
                    timeoutId = window.setTimeout(() => {
                        this.callbacks.delete(id);
                        reject(new Error(`Message ${type} @ ${id} timed out`));
                    }, timeout);
                }
                this.callbacks.set(id, (res) => {
                    if (timeoutId !== undefined)
                        window.clearTimeout(timeoutId);
                    this.callbacks.delete(id);
                    resolve(res);
                });
            });
        });
    }
}
exports.MessageService = MessageService;
